// packages/console/src/components/ModeToggle.tsx
//
// The file/live console mode toggle. A two-segment TChip-style control matching
// the design system's uppercase toggle chip: the active segment is filled and
// blue-bordered, the inactive one is a bordered ghost. It carries no data of its
// own; it flips the top-level `mode` the console shell holds, and the shell
// swaps FileTranscoder for LiveTranscoder in place (no router).

export type ConsoleMode = "file" | "live";

const SEGMENTS: { id: ConsoleMode; label: string }[] = [
  { id: "file", label: "File" },
  { id: "live", label: "Live" },
];

export function ModeToggle({ mode, onMode }: { mode: ConsoleMode; onMode: (m: ConsoleMode) => void }) {
  return (
    <div
      role="tablist"
      aria-label="Console mode"
      style={{
        display: "flex",
        gap: 4,
        padding: 3,
        borderRadius: "var(--r-sm)",
        border: "1px solid var(--line-strong)",
        background: "var(--bg-input)",
      }}
    >
      {SEGMENTS.map((s) => {
        const active = mode === s.id;
        return (
          <button
            key={s.id}
            className="ae-b"
            role="tab"
            aria-selected={active}
            onClick={() => onMode(s.id)}
            style={{
              font: "600 10px var(--font-sans)",
              letterSpacing: ".11em",
              textTransform: "uppercase",
              padding: "5px 12px",
              borderRadius: "var(--r-xs)",
              cursor: "pointer",
              whiteSpace: "nowrap",
              background: active ? "var(--blue-500)" : "transparent",
              border: "1px solid transparent",
              color: active ? "#fff" : "var(--fg3)",
            }}
          >
            {s.label}
          </button>
        );
      })}
    </div>
  );
}
